import { BaseDto } from "src/dtos/common/baseDto";

export interface TqcSolutionAnalDto extends BaseDto {
	analysisDt: string;
	znAm: number;
	znPm: number;
	naohAm: number;
	naohPm: number;
	znInputQty: number;
	naohInputQty: number;
	znReanalysisValue: number;
	naohReanalysisValue: number;
	remark: string;

	inserted: boolean;
	isModified: boolean;
}

export const defaultTqcSolutionAnalDto: TqcSolutionAnalDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	analysisDt: '',
	znAm: 1,
	znPm: 1,
	naohAm: 1,
	naohPm: 1,
	znInputQty: 0,
	naohInputQty: 0,
	znReanalysisValue: 0,
	naohReanalysisValue: 0,
	remark: '',

	inserted: false,
	isModified: false,
};
